import { Documents } from "../../models/documents.interface";

export function getVerificationProfileUploadedDocs(uploadedDocs: Documents | '' | undefined): Documents {
  if (uploadedDocs && typeof uploadedDocs === 'object') {
    return { id: uploadedDocs?.id || '', titleDeed: uploadedDocs?.titleDeed || '' };
  }

  return { id: '', titleDeed: '' };
}